import { createContext, useContext } from 'react';

// Keep context identity independent of either language's translation downloads.
export const LanguageContext = createContext(null);
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
}
export default useLanguage;